import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Color } from '../../../config/Color';
import { SharedScreenName } from '../../../config/FlowTypes';
import { useAppStore } from '../../../store/Store';
import { clockGreen } from '../../assets/images/Icons';
import { useFlowNavigator } from '../../flows/FlowNavigation';
import { Body } from '../../styles/Typography';
import { formatSecondsRemainingAsTime, useCountdownTimer } from '../CheckoutInfo/CountdownTimer';
import { COUNTDOWN_FROM_SECONDS } from '../CheckoutInfo/ProductDetails';

/**
 * Control's 15-minute "program saved" countdown as one slim row. Like Control's, it sends the
 * person back to their results at zero, so callers don't render it on /start.
 */
export const HeldCountdown: FunctionComponent = () => {
  const navigation = useFlowNavigator();
  const paymentLoading = useAppStore((state) => state.purchase.payment.loading);
  const secondsRemaining = useCountdownTimer(COUNTDOWN_FROM_SECONDS, () => {
    // Leaving mid-payment unmounts the form that moves them on once the payment succeeds.
    if (!paymentLoading) {
      navigation.goTo(SharedScreenName.Results);
    }
  });

  return (
    <Bar data-test="countdownTimer">
      <img src={clockGreen} alt="" width={16} height={16} />
      <Message>Your program is held for 15 minutes</Message>
      <Time>{formatSecondsRemainingAsTime(secondsRemaining)}</Time>
    </Bar>
  );
};

const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing._10px};
  height: 44px;
  padding: ${({ theme }) => `0 ${theme.spacing._16px}`};
  border-radius: 999px;
  background: ${Color.surface.onAccent};
  border: 0.6px solid ${Color.decorative.default};
`;

const Message = styled(Body)`
  flex: 1;
  margin: 0;
  font-size: 13px;
  color: ${Color.content.muted};
`;

const Time = styled(Body)`
  margin: 0;
  font-size: 15px;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-variant-numeric: tabular-nums;
`;
